import { Component, Input } from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

const FILE_PDF_ICON = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>file-pdf-box</title><path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M9.5 11.5C9.5 12.3 8.8 13 8 13H7V15H5.5V9H8C8.8 9 9.5 9.7 9.5 10.5V11.5M14.5 13.5C14.5 14.3 13.8 15 13 15H10.5V9H13C13.8 9 14.5 9.7 14.5 10.5V13.5M18.5 10.5H17V11.5H18.5V13H17V15H15.5V9H18.5V10.5M12 10.5H13V13.5H12V10.5M7 10.5H8V11.5H7V10.5Z" /></svg>
`;

const FILE_PNG_ICON = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>file-png-box</title><path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M9 11.5C9 12.3 8.3 13 7.5 13H6.5V15H5V9H7.5C8.3 9 9 9.7 9 10.5V11.5M14 15H12.5L11.5 12.5V15H10V9H11.5L12.5 11.5V9H14V15M19 10.5H16.5V13.5H17.5V12H19V13.7C19 14.4 18.5 15 17.7 15H16.4C15.6 15 15.1 14.3 15.1 13.7V10.4C15 9.7 15.5 9 16.3 9H17.6C18.4 9 18.9 9.7 18.9 10.3V10.5H19M6.5 10.5H7.5V11.5H6.5V10.5Z" /></svg>
`;

const FILE_JPG_ICON = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>file-jpg-box</title><path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M9 13.5C9 14.6 8.1 15 7 15S5 14.6 5 13.5V12H6.5V13.5H7.5V9H9V13.5M14 11.5C14 12.3 13.3 13 12.5 13H11.5V15H10V9H12.5C13.3 9 14 9.7 14 10.5V11.5M19 10.5H16.5V13.5H17.5V12H19V13.7C19 14.4 18.5 15 17.7 15H16.4C15.6 15 15.1 14.3 15.1 13.7V10.4C15 9.7 15.5 9 16.3 9H17.6C18.4 9 18.9 9.7 18.9 10.3V10.5M11.5 10.5H12.5V11.5H11.5V10.5Z" /></svg>
`;

const FILE_DEFAULT_ICON = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>file</title><path d="M13,9V3.5L18.5,9M6,2C4.89,2 4,2.89 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2H6Z" /></svg>
`;

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'edt-file-item',
  standalone: true,
  imports: [MatIconModule],
  template: `
    <div class="file-upload">
      <div class="circle-items rounded-circle">
        <mat-icon
          [svgIcon]="type_file.get(type ?? 'file_default') ?? 'file_default'"
        ></mat-icon>
      </div>
      @if (!onlyIcon) {

      {{ name }}

      }
    </div>
  `,
  styles: [
    '.file-upload{display:flex; align-items:center;}',
    '.circle-items{background-color: #3f6ad829!important; display:flex; align-items:center;justify-content: center; width: 44px;height: 44px;}',
    '.rounded-circle{border-radius: 50%;}',
  ],
})
export class ItemFileComponent {
  @Input() type: string | null = null;
  @Input() name: string | null = null;
  @Input() onlyIcon = false;

  type_file = new Map([
    ['image/jpeg', 'file_jpg'],
    ['image/png', 'file_png'],
    ['application/pdf', 'file_pdf'],
  ]);

  constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
    iconRegistry.addSvgIconLiteral(
      'file_pdf',
      sanitizer.bypassSecurityTrustHtml(FILE_PDF_ICON)
    );

    iconRegistry.addSvgIconLiteral(
      'file_png',
      sanitizer.bypassSecurityTrustHtml(FILE_PNG_ICON)
    );

    iconRegistry.addSvgIconLiteral(
      'file_jpg',
      sanitizer.bypassSecurityTrustHtml(FILE_JPG_ICON)
    );

    iconRegistry.addSvgIconLiteral(
      'file_default',
      sanitizer.bypassSecurityTrustHtml(FILE_DEFAULT_ICON)
    );
  }
}

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'edt-size-file',
  standalone: true,
  imports: [],
  template: ` <div>{{ formatBytes(bytes) }}</div> `,
  styles: [],
})
export class SizeFileComponent {
  @Input() bytes = 0;

  /**
   *
   * @param bytes Number of bytes in the file
   * @param decimals Number of decimals
   * @returns string Returns in format `${number}${size}`
   */

  formatBytes(bytes: number, decimals = 2) {
    if (!+bytes) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PiB', 'EiB', 'ZiB', 'YiB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
  }

  /**
   *
   * @param bytes Number of bytes in the file
   * @returns string Returns in format `${number}${size}`
   */

  returnFileSize(bytes: number): string | null {
    if (bytes < 1024) {
      return `${bytes} bytes`;
    } else if (bytes >= 1024 && bytes < 1048576) {
      return `${(bytes / 1024).toFixed(1)} KB`;
    } else if (bytes >= 1048576) {
      return `${(bytes / 1048576).toFixed(1)} MB`;
    }
    return null;
  }
}
